import { IDataEvent } from "@multiweb/types/contracts";
import { Event } from "Global/Base/Events";
import { IOWObject } from "./DataTypes/IOWObject";
import { IDataEventsManager } from "./IDataEventsManager";
import { IWFOpenFormEventArgs, IWorkflowItemsResult, IWorkflowManager, IWorkflowMenuItem } from "./IWorkflowManager";
import { OWManager } from "./OWManager";
import { RequestContext } from "./RequestContext";

export class WorkflowManager implements IWorkflowManager {
    private readonly _dataEventsManager: IDataEventsManager;
    public readonly openFormReceived: Event<IWorkflowManager, IWFOpenFormEventArgs> = new Event<IWorkflowManager, IWFOpenFormEventArgs>();

    // arrow funkce nabindovaná na this sloužící jako instance listeneru
    private _onWfOpenFormReceived = (message: IDataEvent) => {
        this.openFormReceived.trigger(this, { message: message, handled: false });
    };

    constructor(dataEventsManager: IDataEventsManager) {
        this._dataEventsManager = dataEventsManager;
    }

    public subscribeWFOpenForm(): void {
        this._dataEventsManager.subscribeWFOpenForm(this._onWfOpenFormReceived);
    }

    public unsubscribeWFOpenForm(): void {
        this._dataEventsManager.unsubscribeWFOpenForm(this._onWfOpenFormReceived);
    }
    public async getWFItems(object: IOWObject, checkWf: boolean, requestContext?: RequestContext): Promise<IWorkflowItemsResult> {
        if (!object)
            return null;

        if (checkWf == undefined) {
            checkWf = await OWManager.isWFDefinedToClass(object.objectName, requestContext);
        }
        if (!checkWf)
            return null;

        const hasWf = await object.hasWf();
        if (!hasWf)
            return null;

        const items = await OWManager.objectWFMenu(object.instanceID, requestContext);

        return new WorkflowItemsResult(items, checkWf);
    }
}

/**
 * Datová třída obsahující výsledek dotazu na WF akce
 */
class WorkflowItemsResult implements IWorkflowItemsResult {
    private _workflowMenuItems: IWorkflowMenuItem[];
    private _checkWorkflow: boolean;

    public get workflowMenuItems(): IWorkflowMenuItem[] {
        return this._workflowMenuItems;
    }

    public set workflowMenuItems(value: IWorkflowMenuItem[]) {
        this._workflowMenuItems = value;
    }

    public get checkWorkflow(): boolean {
        return this._checkWorkflow;
    }

    public set checkWorkflow(value: boolean) {
        this._checkWorkflow = value;
    }

    constructor(items: IWorkflowMenuItem[], checkWf: boolean) {
        this._workflowMenuItems = items;
        this._checkWorkflow = checkWf;
    }
}
